enum ContentContainerPaddingSize {
  XXS = "xxs",
  XS = "xs",
  SM = "sm",
  MD = "md",
  LG = "lg",
  XL = "xl",
  XXL = "xxl",
}

// eslint-disable-next-line import/prefer-default-export
export { ContentContainerPaddingSize };
